import { Phone, MapPin, FileCheck2 } from "lucide-react";
import { SITE } from "@/lib/site";
import { Reveal, SectionHeading } from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";
import BookingForm from "@/components/BookingForm";

export default function Kontakt() {
  return (
    <main className="pt-28 md:pt-36 pb-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="font-mono-brand text-xs md:text-sm tracking-[0.3em] text-electric mb-4">KONTAKT</p>
          <h1 className="font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white">
            Hör av dig — <span className="text-gradient-blue">vi svarar gärna</span>
          </h1>
        </Reveal>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1fr_1.4fr] items-stretch">
          <Reveal className="h-full">
            <div className="rounded-2xl border border-metallic/70 bg-surface p-8" data-testid="contact-info-card">
              <p className="font-mono-brand text-xs tracking-[0.3em] text-electric mb-6">KONTAKTUPPGIFTER</p>
              <ul className="space-y-6 text-sm">
                <li>
                  <a href={`tel:${SITE.phone}`} data-testid="contact-info-phone" className="flex items-start gap-3 group">
                    <Phone size={18} className="text-brand mt-0.5 shrink-0" />
                    <span>
                      <span className="block text-slate-400">Telefon</span>
                      <span className="block font-mono-brand text-white group-hover:text-electric transition-colors">
                        {SITE.phoneDisplay}
                      </span>
                    </span>
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin size={18} className="text-brand mt-0.5 shrink-0" />
                  <span>
                    <span className="block text-slate-400">Adress</span>
                    <span className="block text-white">
                      {SITE.address}
                      <br />
                      {SITE.zip}
                    </span>
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <FileCheck2 size={18} className="text-brand mt-0.5 shrink-0" />
                  <span>
                    <span className="block text-slate-400">Företagsinformation</span>
                    <span className="block text-white">{SITE.fskatt}</span>
                    <span className="block font-mono-brand text-xs text-slate-400 mt-1">
                      Org.nr {SITE.orgnr} · Ägare: {SITE.owner}
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="h-full">
            <div className="rounded-2xl border border-metallic/70 bg-surface p-8" data-testid="contact-message-card">
              <SectionHeading eyebrow="SKICKA ETT MEDDELANDE" title="Skriv till oss" className="!mb-6" />
              <ContactForm />
            </div>
          </Reveal>
        </div>

        <div id="boka" className="mt-16 scroll-mt-28">
          <Reveal>
            <div className="rounded-3xl border border-brand/40 bg-gradient-to-br from-surface via-surface-2 to-surface p-8 md:p-12 grain" data-testid="booking-section">
              <SectionHeading
                eyebrow="BOKA VISNING"
                title="Boka en visningstid hos oss"
                className="text-center"
              />
              <p className="mt-4 text-center text-slate-400 max-w-lg mx-auto">
                Visningar sker <span className="text-electric font-medium">endast efter tidsbokning, dygnet runt</span> —
                fyll i formuläret nedan så återkommer vi med en bekräftad tid. Du kan också ringa oss direkt.
              </p>
              <div className="mt-10 max-w-2xl mx-auto">
                <BookingForm />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </main>
  );
}
